import React, { useState, useEffect } from 'react';
import './Register.css';
import Navigation from '../../navigation/Navigation';
import PageHeading from '../../shared/pageHeading/PageHeading';
//import Numpad from './subcomponents/Numpad'
//import RegisterInputs from './subcomponents/RegisterInputs'
import TotalSum from './subcomponents/TotalSum';
import Transactions from './subcomponents/Transactions';
import { getDatabase, onValue, push, ref } from 'firebase/database';
import AlertManager from '../../shared/AlertManager/AlertManager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faUndo } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../../context/AuthContext';
const Register = () => {
	const [inputSumValue, setInputSumValue] = useState('');
	const [inputTableValue, setInputTableValue] = useState('');
	const [transactions, setTransactions] = useState([]);
	const [confirmNewCustomer, setConfirmNewCustomer] = useState(false);
	const [tables, setTables] = useState([]);
	const [loading, setLoading] = useState(false);
	const [alerts, setAlerts] = useState({
		visibility: false
	});
	const { currentUser } = useAuth();

	useEffect(() => {
		const db = getDatabase();
		const tablesRef = ref(db, 'tables/');
		onValue(tablesRef, snapshot => {
			if (snapshot.exists()) {
				setTables(snapshot.val());
			}
		});
		let sessionTransactions = JSON.parse(sessionStorage.getItem('transactions'));
		setTransactions(sessionTransactions ? sessionTransactions : []);
	}, []);
	useEffect(() => {
		window.sessionStorage.setItem('transactions', JSON.stringify(transactions));
	}, [transactions]);
	const handleNewCustomer = async () => {
		setInputSumValue('');
		setInputTableValue('');
		setTransactions([]);
		setConfirmNewCustomer(false);
		navigator.vibrate(25);
	};
	const handleConfirmNewCustomer = () => {
		setConfirmNewCustomer(prevVal => !prevVal);
	};
	const handleAddTransaction = async () => {
		setLoading(true);
		let table = Number(inputTableValue);
		let price = Number(parseFloat(inputSumValue.replace(/,/g, '.')));
		console.log("price",price)
		if (!Number(price) || !Number(table)) {
			setAlerts({
				visibility: true,
				message: 'Något är fel med den inmatade datan!',
				type: 'error',
				duration: 'infinite'
			});
			setLoading(false);
			return;
		}
		if (!tables[table.toString()]) {
			setAlerts({
				visibility: true,
				message: 'Bordsnummer: ' + table + ' finns inte',
				type: 'error',
				duration: 'infinite'
			});
			setLoading(false);
			return;
		}
		try {
			let data = {
				sum: price,
				time: Date.now(),
				addedBy: currentUser.uid
			};
			const db = getDatabase();
			let transaction = await push(ref(db, 'transactions/' + tables[table.toString()]), data);
			data.key = transaction.key;
			data.table = {
				number: table,
				key: tables[table.toString()]
			};
			setTransactions([...transactions, data]);
			setInputSumValue('');
			setInputTableValue('');
			setAlerts({
				visibility: false
			});
			navigator.vibrate(25);
			setLoading(false);
		} catch (error) {
			console.error(error);
			setLoading(false);
		}
	};
	return (
		<>
			<Navigation />
			<div className='AppContents'>
				<div className='Container'>
					<PageHeading heading={'Kassa'} />
					<AlertManager
						data={{
							alerts: alerts,
							setAlerts: setAlerts
						}}
					/>
					<TotalSum transactions={transactions} />
					<section className='RegisterInputs'>
						<label>Bordsnummer</label>
						<label>Pris</label>
						<input
							value={inputTableValue}
							inputmode='numeric'
							key={'tableInput'}
							placeholder='Nr.'
							onChange={e => {
								setInputTableValue(e.target.value);
							}}
						/>
						<input
							value={inputSumValue}
							inputmode='decimal'
							key={'priceInput'}
							placeholder='€'
							onChange={e => {
								setInputSumValue(e.target.value);
							}}
						/>
						{!confirmNewCustomer ? (
							<button onClick={() => handleConfirmNewCustomer()} disabled={loading}>
								Ny kund
							</button>
						) : (
							<div className='ConfirmNewCustomer'>
								<div onClick={() => handleNewCustomer()}>
									<FontAwesomeIcon icon={faCheckCircle} />
								</div>
								<div onClick={() => handleConfirmNewCustomer()}>
									<FontAwesomeIcon icon={faUndo} />
								</div>
							</div>
						)}
						<button onClick={() => handleAddTransaction()} disabled={loading}>
							Lägg till
						</button>
					</section>

					<Transactions
						data={{
							transactions: transactions,
							setTransactions: setTransactions
						}}
					/>
				</div>
			</div>
		</>
	);
};

export default Register;
/*

<Numpad
						data={{
							activeInput: activeInput,
							setInputSumValue: setInputSumValue,
							setInputTableValue: setInputTableValue,
							toggleNumpad: toggleNumpad,
						}}
					/>
					<ConfirmButton
						data={{
							tables: tables,
							transactions: transactions,
							setTransactions: setTransactions,
							setInputSumValue: setInputSumValue,
							setInputTableValue: setInputTableValue,
							inputSumValue: inputSumValue,
							inputTableValue: inputTableValue,
							alerts: alerts,
							setAlerts: setAlerts,
						}}
					/>
					*/

